import React, {Component}  from 'react';
import _                   from 'lodash';
import AppActions          from './../../actions/AppActions';

class BoundEnumSelect extends Component {
    render() {
        const {path, value, enumType, filter, onEnumSelected, onChangeListener, ...componentProps} = this.props;

        const applyFilter = _.isFunction(filter) ? filter : (val) => true;

        const handleChange = (event) => {
            const element = event.target;
            const newValue = _.isFunction(enumType.parse) ? enumType.parse(element.value) : element.value;

            if (_.isFunction(onEnumSelected)) {
                onEnumSelected(newValue);
            } else {
                AppActions.updateState(path, newValue);
            }

            if (_.isFunction(onChangeListener)) {
                onChangeListener(newValue, path);
            }
        };

        const options = _(enumType)
            .filter(applyFilter)
            .map(val => _.isFunction(val) ? null : <option key={val} value={val}>{enumType.nameOfEnumValue(val)}</option>)
            .value();

        return <select onChange={handleChange} {...componentProps} value={value}>
            {options}
        </select>
    }
}

export default BoundEnumSelect;